[
  {
    "code": "HT-AR",
    "name": "Artibonite"
  },
  {
    "code": "HT-CE",
    "name": "Centre"
  },
  {
    "code": "HT-GA",
    "name": "Grande-Anse"
  },
  {
    "code": "HT-NI",
    "name": "Nippes"
  },
  {
    "code": "HT-ND",
    "name": "Nord"
  },
  {
    "code": "HT-NE",
    "name": "Nord-Est"
  },
  {
    "code": "HT-NO",
    "name": "Nord-Ouest"
  },
  {
    "code": "HT-OU",
    "name": "Ouest"
  },
  {
    "code": "HT-SD",
    "name": "Sud"
  },
  {
    "code": "HT-SE",
    "name": "Sud-Est"
  }
]